import { isAfter, isBefore, startOfDay } from 'date-fns';

/** Calendar day falls before local "today" or after max selectable boundary (inclusive of maxSelectableDate). */
export const isOutOfSelectableRange = (
  dayCandidate: Date,
  now: Date,
  maxSelectableDate: Date
): boolean =>
  isBefore(startOfDay(dayCandidate), startOfDay(now)) ||
  isAfter(startOfDay(dayCandidate), maxSelectableDate);
